<template>
  <div class="basket">
    <div class="p-b-40">
      <div>
        <el-row type="flex" justify="center">
          <el-col :xs="20" :sm="20" :md="12" :lg="12" :xl="8">
            <div class="checkout-area">
              <div>
                <div>
                  <div>
                    <div class="bill-details p-t-0 text-center">
                      <h6>Төлбөрийн хэлбэр</h6>
                      <el-radio-group v-model="pay_type" size="mini">
                        <el-radio label="1">
                          Шилжүүлэг
                        </el-radio>
                        <el-radio label="3">
                          Qpay
                        </el-radio>
                      </el-radio-group>
                    </div>
                    <div class="product-order p-l-50 p-r-50 p-t-30 p-b-55 m-t-50 m-b-50">
                      <div class="payment_layout" v-show="pay_type == '1'">
                        <b>Харилцагч банк: </b>"ХХБ банк"<br>
                        <b>Данс эзэмшигч нэр: </b> "Саруулбат"<br>
                        <b>Дансны дугаар: </b>404320221<br>
                        <b>Мөнгөн дүн: </b>{{ lastOrderGetter.total_amount | formatCurrency }}<br>
                        <b>Гүйлгээний утга: </b>{{ lastOrderGetter.id }}<br>/ Тухайн өдрийн 18:00-с хойш төлбөр хийгдсэн тохиолдол дараа өдрийн захиалганд шилжихийг анхаарна уу.
                      </div>
                      <div v-show="pay_type == '3'" class="text-center">
                        <el-image
                          style="width: 250px; height: 250px"
                          :src="qpayImg"
                          fit="fill"
                        /><br>
                        Мөнгөн дүн: <b>{{ lastOrderGetter.total_amount | formatCurrency}}</b><br>
                        Гүйлгээний утга: <b>{{ lastOrderGetter.id }}</b>
                      </div><br><br>
                      <div class="signup_button_padding">
                        <router-link class="cursor menu_text" to="/">
                          <el-button class="white_text thin_text signup_button">{{ $t('successorder') }}</el-button>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Qpay from '../../assets/iteever_logo_hondlon.png'
import {
  mapGetters
} from 'vuex'
export default {
  name: 'PaymentAuthComponent',
  data () {
    return {
      valueNumber: 1,
      checked: false,
      pay_type: '1',
      qpayImg: Qpay
    }
  },
  computed: {
    ...mapGetters([
      'lastOrderGetter'
    ])
  },
  methods: {
    goToHome () {
      this.$router.push({
        path: '/'
      })
    },
    totalAmountCalc () {
      let sum = 0
      let total = 0
      this.lastOrderGetter.products.forEach(element => {
        sum = element.item_price * element.item_count
        total = sum + total
      })
      return total
    }
  }

}
</script>

<style>
  .checkout-area {
    padding-top: 40px;
  }
  .bill-details h6 {
  font-size: 24px;
  line-height: 48px;
  color: #292929;
  }
  .text-center {
    text-align: center;
  }
  .product-order {
    background-color: rgb(247, 247, 247);
  }
  .payment_layout{
    font-size: 14px;
    font-family: 'Montserrat', sans-serif !important;
    align-items: center;
    font-weight: 500;
    color: black;
    line-height: 30px;
  }
</style>
